import _ from 'lodash';
import { check } from 'recheck';

/**
 * @param keyword
 * @param strData
 * @param regexOpt
 * * Options:
 * - g	Global search.
 * - i	Case-insensitive search.
 * - m	Multi-line search.
 * - s	Allows . to match newline characters.
 * - u	"unicode"; treat a pattern as a sequence of unicode code points
 * - y	Perform a "sticky" search that matches starting at the current position in the target string
 * @returns {boolean}
 */
export const containsString = (keyword, strData, regexOpt) => {
  // Input validation
  if (!keyword || !strData) return false;

  if (regexOpt) {
    try {
      // Sanitize flags
      const sanitizedFlags = regexOpt.replace(/[^gimsuy]/g, '');

      // Escape metacharacters
      const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

      // ReDoS check
      const recheckResult = check(escapedKeyword, sanitizedFlags);

      // Handle vulnerability
      if (recheckResult.status === 'vulnerable') {
        throw new Error(`ReDoS (${recheckResult.complexity}): ${escapedKeyword}`);
      }

      // Safe to execute - input is escaped and validated by recheck above
      // no-dd-sa:javascript-node-security/detect-non-literal-regexp,javascript-browser-security/regexp-non-literal
      const re = new RegExp(escapedKeyword, sanitizedFlags);
      return re.test(strData);

    } catch (error) {
      // Safe fallback
      return strData.includes(keyword);
    }
  }

  // No regex: simple string search
  return strData.includes(keyword);
};

export const searchInObject = (o, k, regexOpt, fields) => {
  if (fields && fields.length > 0) {
    for (let i = 0; i < fields.length; i++) {
      const v = _.get(o, fields[i]);
      if (v && containsString(k, v, regexOpt)) {
        return true;
      }
    }
  } else {
    for (var field in o) {
      if (!o.hasOwnProperty(field)) continue;
      if (o[field] && containsString(k, o[field], regexOpt)) {
        return true;
      }
    }
  }

  return false;
};